<script setup lang="ts">
import { ChevronDownIcon } from "~/icons";

defineProps<{
  text: string;
  disabled?: boolean;
}>();
</script>

<template>
  <div
    class="flex items-center justify-between rounded-md border border-md py-1.5 pr-1 pl-3 text-left text-sm text-md shadow-xs select-none"
    :class="disabled ? 'pointer-events-none opacity-50' : 'hover:bg-lt'">
    <span class="truncate">{{ text }}</span>
    <ChevronDownIcon class="icon-sm text-lt" />
  </div>
</template>
